import type { ComponentProps } from 'react';
import { Icon, Image } from '@customerio/pluma-components/react';

type IconSize = NonNullable<ComponentProps<typeof Icon>['size']>;

const SIZES: Record<string, number> = {
  xxs: 12,
  xs: 14,
  sm: 16,
  md: 24,
  lg: 32,
  xl: 48,
};

type IntegrationIconProps = {
  integration: {
    icon?: string;
    imageSrc?: string;
    title?: string;
  };
  size?: IconSize;
};

/** Renders a Pluma icon when the integration has one, otherwise its logo image. */
export function IntegrationIcon({ integration, size = 'md' }: IntegrationIconProps) {
  if (integration.icon != null && integration.icon !== '') {
    return (
      <Icon
        name={
          // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
          integration.icon as ComponentProps<typeof Icon>['name']
        }
        size={size}
        data-test-icon
      />
    );
  }

  if (integration.imageSrc != null && integration.imageSrc !== '') {
    const sizeAsPixels = size === 'fill' ? '100%' : String(SIZES[size] ?? SIZES.md);
    const maxSize = `${sizeAsPixels}px`;
    return (
      <Image
        data-test-img
        src={integration.imageSrc}
        width={sizeAsPixels}
        height={sizeAsPixels}
        alt={integration.title}
        objectFit="contain"
        style={{ maxWidth: maxSize, maxHeight: maxSize }}
      />
    );
  }

  return null;
}
